<form #form="ngForm" novalidate data-test="user-invite-form" (submit)="onInviteUser()">
  <div class="input-group">
    <input
      name="email"
      data-cy="invite-user-email"
      id="email-field"
      type="email"
      i18n-placeholder="Email address..."
      placeholder="Email address..."
      class="form-control"
      required
      ccFocus
      #email="ngModel"
      [pattern]="emailRegex"
      [(ngModel)]="model.email"
      (keyup)="resetSubmission($event)"
    />
    <button
      class="btn cc-btn-primary-constructive btn-invite-member text-white px-4"
      type="submit"
      id="user-invite-button"
      [class.disabled-button]="
        email.invalid || model.isWorkplaceDomain || model.isPublicDomain || model.isExistingUserDifferentType
      "
      [ccBusyButton]="model.working"
      i18n
    >
      Invite
    </button>
    <div class="ml-3 align-self-center" *ngIf="model.submitted">
      <span class="sm-text-default-red" i18n *ngIf="email.invalid && email.errors?.required">
        Email is required
      </span>
      <span class="sm-text-default-red" i18n *ngIf="email.invalid && email.errors?.pattern">
        Invalid email
      </span>
      <span class="sm-text-default-red" i18n *ngIf="!email.invalid && model.isExistingUser">
        User already has access
      </span>
      <span
        class="sm-text-default-red"
        i18n
        *ngIf="
          !email.invalid &&
          !model.isExistingUser &&
          model.isWorkplaceDomain &&
          !model.isExistingUserDifferentType
        "
      >
        Visitors must have an external email domain
      </span>
      <span
        class="sm-text-default-red"
        i18n
        *ngIf="!email.invalid && model.isPublicDomain && !model.isExistingUserDifferentType"
      >
        Visitor emails cannot use public domains eg. @gmail
      </span>
      <span class="sm-text-default-red" i18n *ngIf="!email.invalid && model.isExistingUserDifferentType">
        {{ differentUserTypeErrorMessages[userType] }}
      </span>
    </div>
  </div>
</form>
